import type { EventTracker } from '../analytics/event-tracker'

export type VoiceflowEventContext = {
  brandName: string
  vfProjectId: string
  publisher: string
}

export const VF_EVENT_TYPES = {
  OPEN: 'voiceflow:open',
  CLOSE: 'voiceflow:close',
  INTERACT: 'voiceflow:interact',
} as const

export const handleVoiceflowMessage = ({ data }: MessageEvent, eventTracker: EventTracker) => {
  try {
    if (typeof data !== 'string' || data.charAt(0) !== '{') {
      return
    }

    const { type, ...otherDataFields } = JSON.parse(data) as { type?: string }
    if (!type) {
      return
    }

    switch (type) {
      case VF_EVENT_TYPES.OPEN:
      case VF_EVENT_TYPES.CLOSE:
        eventTracker.track(type)
        break

      case VF_EVENT_TYPES.INTERACT: {
        const { payload } = otherDataFields as {
          payload?: {
            action?: {
              type?: string
              payload?: string | { label?: string }
            }
            session?: {
              status?: string
              turns?: unknown[]
            }
          }
        }

        const details = {
          actionType: payload?.action?.type || 'unknown',
          sessionStatus: payload?.session?.status || 'unknown',
          turnCount: payload?.session?.turns?.length?.toString() || '0',
          hasPayload: payload ? 'true' : 'false',
          ...(payload?.action?.type === 'text' &&
            typeof payload.action.payload === 'string' && { text: payload.action.payload }),
          ...(payload?.action?.payload &&
            typeof payload.action.payload === 'object' &&
            payload.action.payload.label && { label: payload.action.payload.label }),
        }

        eventTracker.track(type, details)
        break
      }
    }
  } catch {
    // Ignore malformed JSON messages
  }
}

export const createVoiceflowMessageHandler = (eventTracker: EventTracker) => {
  return (event: MessageEvent) => handleVoiceflowMessage(event, eventTracker)
}
